<template>
  <div style="height: calc(100vh - 196px)">
    <vxe-toolbar id="toolbarId_tr3" export :refresh="{ query: RefreshList }">
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>

        <!-- <el-button
          v-if="getLimit('waybillManage_un_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button> -->

        <el-button @click="columnSettingVisible = true">列设置</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      v-if="showTable"
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      show-footer
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      align="center"
      class="mytable-style"
      show-overflow
      @sort-change="sortList"
    >
      <vxe-table-column
        v-for="col in columns"
        :key="col.value"
        v-if="col.visible"
      >
        <vxe-table-column
          :field="col.value"
          :title="col.name"
          :min-width="col.minWidth || 160"
        >
          <template #default="scope">
            <div class="oeder_num_box">
              <el-tooltip
                class="item"
                effect="dark"
                :content="String(formatterSwitch(scope))"
                placement="top-start"
              >
                <span
                  class="copy_text_cursor"
                  @click="copyText(formatterSwitch(scope))"
                  >{{ formatterSwitch(scope) }}</span
                ></el-tooltip
              >
            </div>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <!-- 定位状态 -->
          <template v-if="col.value === 'locationStatus'">
            <el-select
              v-model="listQuery.locationStatus"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in locationStatusList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select>
          </template>
          <template
            v-if="
              col.value === 'gpsNo' ||
                col.value === 'gpsModel' ||
                col.value === 'licenseNumber' ||
                col.value === 'driverName' ||
                col.value === 'driverPhone' ||
                col.value === 'lastLoginLocation'
            "
          >
            <el-input
              v-model="listQuery[col.value]"
              placeholder="请输入"
              clearable
            />
          </template>

          <!--托运人实付运费 -->
          <template v-if="col.value === 'batteryLevel'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery[col.value + 'Start']"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery[col.value + 'End']"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>

          <template
            v-if="
              col.value === 'lastLoginTime' ||
                col.value === 'offlineStartTime' ||
                col.value === 'serviceExpireTime' ||
                col.value === 'gmtCreated'
            "
          >
            <el-date-picker
              v-model="listQuery[col.value]"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, col.value)"
            />
          </template>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column title="操作" width="200" fixed="right">
          <template v-slot="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              content="查看轨迹"
              placement="top"
            >
              <vxe-button
                type="text"
                class="op-icon-btn"
                @click="historyTrackByGpsNoApi(row)"
              >
                <em class="el-icon-location-information" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="操作记录"
              placement="top"
            >
              <vxe-button
                type="text"
                class="op-icon-btn"
                @click="handleOperLog(row)"
              >
                <em class="el-icon-document" />
              </vxe-button>
            </el-tooltip>
          </template>
        </vxe-table-column>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <el-dialog
      title="列设置"
      :visible.sync="columnSettingVisible"
      width="480px"
      custom-class="column-setting-dialog"
    >
      <ColumnDrag :columns="columns" @update="applyColumnSettings" />
    </el-dialog>
    <vxe-modal
      v-model="positionFlag"
      title="运单轨迹"
      width="88%"
      height="96%"
      resize
      remember
      @close="positionFlag = false"
    >
      <Position
        :isLightType="true"
        :lightTrackList="lightTrackList"
        :positoin-info="positoinInfo"
      ></Position>
    </vxe-modal>
    <vxe-modal
      v-model="isLogList"
      title="操作日志"
      width="900"
      height="700"
      resize
    >
      <LogList v-if="isLogList" :row-info="rowInfo" />
    </vxe-modal>
  </div>
</template>
<script>
import { historyTrackByGpsNo } from "@/api/gps";
import LogList from "../driver/platVehicle/components/LogList.vue";
import ColumnDrag from "@/components/ColumnDrag";
import request from "@/utils/request";
import { baseGpsList } from "@/api/gps";
import Position from "@/views/tms/transportManage/waybillManage/components/components/Position.vue";
export default {
  name: "gpsList",
  components: {
    ColumnDrag,
    Position,
    LogList
  },
  data() {
    return {
      rowInfo: {},
      isLogList: false,
      positionFlag: false,
      positoinInfo: {},
      lightTrackList: [],
      tableData: [],
      columnSettingVisible: false,
      showTable: true,
      locationStatusList: [
        {
          code: 0,
          groupName: "无法定位"
        },
        {
          code: 1,
          groupName: "信号中断"
        },
        {
          code: 2,
          groupName: "未定位"
        },
        {
          code: 3,
          groupName: "车辆静止"
        },
        {
          code: 4,
          groupName: "车辆运动中"
        },
        {
          code: 5,
          groupName: "未绑定"
        },
        {
          code: 6,
          groupName: "未启用"
        },
        {
          code: 8,
          groupName: "数据上传延迟"
        }
      ],
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          name: "定位状态",
          value: "locationStatus",
          visible: true,
          minWidth: 120
        },
        {
          name: "设备号",
          value: "gpsNo",
          visible: true,
          minWidth: 160
        },
        {
          name: "设备型号",
          value: "gpsModel",
          visible: true,
          minWidth: 160
        },
        {
          name: "车牌号",
          value: "licenseNumber",
          visible: true,
          minWidth: 140
        },
        {
          name: "实际承运人姓名",
          value: "driverName",
          visible: true,
          minWidth: 120
        },
        {
          name: "实际承运人电话",
          value: "driverPhone",
          visible: true,
          minWidth: 140
        },
        {
          name: "最近登录时间",
          value: "lastLoginTime",
          visible: true,
          minWidth: 270
        },
        {
          name: "最近登录地点",
          value: "lastLoginLocation",
          visible: true,
          minWidth: 220
        },
        {
          name: "离线开始时间",
          value: "offlineStartTime",
          visible: true,
          minWidth: 270
        },
        {
          name: "离线时长(小时)",
          value: "offlineDuration",
          visible: true,
          minWidth: 270
        },
        {
          name: "剩余电量(%)",
          value: "batteryLevel",
          visible: true,
          minWidth: 270
        },
        {
          name: "服务到期时间",
          value: "serviceExpireTime",
          visible: true,
          minWidth: 270
        },
        {
          name: "创建时间",
          value: "gmtCreated",
          visible: true,
          minWidth: 270
        }
        // {
        //   name: "所属机构",
        //   value: "branchName",
        //   visible: true,
        //   minWidth: 270
        // }
      ]
    };
  },
  created() {
    this.findList();
    let unLoadedColumn = localStorage.getItem("gpsColumn") || "";
    if (unLoadedColumn) {
      let columns = JSON.parse(unLoadedColumn);
      this.columns = columns;
    }
  },
  methods: {
    handleOperLog(item) {
      this.rowInfo = { ...item, reviewGpsCode: item.code };
      this.isLogList = true;
      console.log("操作日志=====", item);
    },
    historyTrackByGpsNoApi(item) {
      historyTrackByGpsNo({
        gpsNo: item.gpsNo
      }).then(res => {
        if (res.status === 0) {
          this.positoinInfo = {
            vehicleLicense: item.licenseNumber || item.vehicleLicense || "",
            fillTime: "",
            signTime: ""
          };
          this.lightTrackList = res.data;
          if (this.lightTrackList && this.lightTrackList.length > 0) {
            this.positionFlag = true;
          } else {
            this.positionFlag = false;
            this.lightTrackList = [];
            this.$message({
              message: "该设备暂无定位信息",
              type: "warning",
              duration: 1500
            });
          }
        }
      });
    },
    findList() {
      this.loading = true;
      let data = { ...this.listQuery };
      delete data.lastLoginTime;
      delete data.serviceExpireTime;
      delete data.gmtCreated;
      delete data.offlineStartTime;
      return new Promise(resolve => {
        request({
          url: "ntocc-basic-api/baseGps",
          method: "get",
          params: { ...data, deleted: "0" }
        }).then(response => {
          this.loading = false;
          const records = response.data.records;
          if (records && records.length > 0) {
            this.tableData = records;
          } else {
            this.tableData = [];
          }
          this.listQuery.total = response.data.total;
          resolve();
        });
      });
    },
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      });
    },
    formatterSwitch(scope) {
      let valueCell = scope.row[scope.column.property];
      if (scope.column.property === "shipmentDeliveryFeePractical") {
        return scope.row.shipmentDeliveryFeePractical || scope.row.taxFee;
      }
      // if (scope.column.property === "price") {
      //   return scope.row.price + scope.row.isTrunkName;
      // }
      if (scope.column.property === "locationStatus") {
        const item = this.locationStatusList.find(
          item => item.code === valueCell
        );
        return item ? item.groupName : "";
      }
      if (scope.column.property === "offlineDuration") {
        return Number(valueCell / 60).toFixed(2);
      }
      if (scope.column.property === "deliveryFeePractical") {
        return scope.row.deliveryFeePractical || scope.row.deliveryFeeDeserved;
      }

      if (scope.column.property === "isTransfer") {
        return valueCell > 0 ? "是" : "否";
      }

      if (scope.column.property === "isUnloadingConfirm") {
        let data = valueCell == 0;
        return data ? "未签收" : "已签收";
      }

      if (scope.column.property === "reportMark") {
        return valueCell > 0 ? "是" : "否";
      }
      if (scope.column.property === "prePay") {
        return Number(valueCell);
      }
      return valueCell;
    },
    bindVehicle(row) {
      this.$message.info("绑定车辆");
    },
    unbindVehicle(row) {
      this.$message.info("解绑车辆");
    },
    viewTrack(row) {
      this.$message.info("查看轨迹");
    },
    viewOperateLog(row) {
      this.$message.info("操作记录");
    },
    applyColumnSettings(payload) {
      this.columns = payload.columns;
      localStorage.setItem("gpsColumn", JSON.stringify(payload.columns));
      this.columnSettingVisible = false;
      this.showTable = false;
      this.$nextTick(() => {
        this.showTable = true;
      });
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.op-icon-btn {
  padding: 0 6px;
}
.op-icon-btn em {
  font-size: 16px;
}
</style>
